import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { primaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface HomepageBlock9Props extends ComponentPropsWithRef<"div"> {
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock9 = forwardRef<HTMLDivElement, HomepageBlock9Props>(
  ({ leftContent, rightContent, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-flex wb-flex-col wb-gap-10 md:wb-grid md:wb-grid-cols-2 lg:wb-grid-cols-3 md:wb-gap-16">
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-flex-col wb-gap-4 md:wb-gap-6 lg:wb-col-span-2 wb-my-auto">
                  {leftContent}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                  {rightContent}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock9.displayName = "HomepageBlock9";
